import Lookup from 'src/componentes/select2';
import stageGateEdit from 'src/paginas/EscritorioProjetos/StageGate/Edit/index';

const StageGateLookup = ({ ...rest }) => (
  <Lookup
    labelKey="nome"
    valueKey="id"
    url="/StageGateLookup"
    editComponent={stageGateEdit}
    {...rest}
  />
);

export default StageGateLookup;
